// src/lib/golfapi.js
// Thin client for the GolfAPI proxy function. Server enforces quota + caching;
// the browser never sees the GolfAPI key. `coordinates` mode costs quota (1.0)
// and caches into course_coordinates — call it deliberately (user-triggered).
//
// Authorization (F-091-T1): reads the current Supabase session and attaches a
// Bearer token so the server can derive requested_by from the JWT for
// provider_request_log attribution. When no session exists (unauth caller),
// the fetch goes out without an Authorization header and the server logs
// requested_by=NULL — matching historical behavior.

import { supabase } from './supabase'

export async function golfapi(mode, payload = {}) {
  const headers = { 'Content-Type': 'application/json' }
  try {
    const { data: { session } = {} } = await supabase.auth.getSession()
    if (session?.access_token) headers.Authorization = `Bearer ${session.access_token}`
  } catch { /* no session → send unauthed, server logs NULL */ }
  const res = await fetch('/.netlify/functions/golfapi', {
    method: 'POST',
    headers,
    body: JSON.stringify({ mode, ...payload }),
  })
  const json = await res.json()
  if (!res.ok) throw new Error(json.error || `golfapi ${res.status}`)
  return json
}
